import type { AnalyticsEvent } from '$lib/services/tracking/googleAnalytics/events';
import type { AnalyticsProperty } from '$lib/services/tracking/googleAnalytics/properties';
import { initializeGA } from '$lib/services/tracking/googleAnalytics/ga';
import { mouseflowOnAnalyticsEvent } from '$lib/services/tracking/mouseflow/mouseflow';

export interface Tracker {
	track: (event: AnalyticsEvent) => void;
	setProperty: (property: AnalyticsProperty) => void;
}

export const { track, setProperty }: Tracker = initializeGA({
	afterSendEvent(event, payload) {
		mouseflowOnAnalyticsEvent(event, payload);
	},
});

export * from './userId';
